import React from 'react';
import { NavLink } from 'react-router-dom';
import { Map as MapIcon, Gem, TrendingUp, Feather, CalendarDays, FlaskConical } from 'lucide-react';
export const explorerLinks = [{
  to: '/guia/evoluciones',
  label: 'Evoluciones y misiones',
  desc: 'Sebina, Marlon, combo y tercera evolución por clase.',
  icon: TrendingUp
}, {
  to: '/guia/alas',
  label: 'Alas y capas',
  desc: 'Recetas de la Chaos Machine paso a paso.',
  icon: Feather
}, {
  to: '/guia/combinaciones',
  label: 'Mascotas y combinaciones',
  desc: 'Dark Horse, Dark Raven, Dinorant, Fenrir y entradas de eventos.',
  icon: FlaskConical
}, {
  to: '/guia/mapas',
  label: 'Mapas, monstruos y spots',
  desc: 'Coordenadas, áreas, accesos por nivel y apariciones de invasión.',
  icon: MapIcon
}, {
  to: '/guia/items',
  label: 'Ítems y drops',
  desc: 'De dónde sale cada ítem: monstruo, evento o caja.',
  icon: Gem
}, {
  to: '/guia/eventos',
  label: 'Eventos',
  desc: 'Horarios configurados, salas por nivel y recompensas.',
  icon: CalendarDays
}];

/** Accesos a las guías interactivas y exploradores, compartidos por la barra lateral y el menú móvil. */
export function ExplorerNavLinks({
  size = 'sm'
}: {
  size?: 'sm' | 'lg';
}) {
  return <ul className="space-y-0.5" data-id="element-368" data-mp="110j68q91fikl">
      {explorerLinks.map(({
      to,
      label,
      icon: Icon
    }) => <li key={to} data-id="element-369" data-mp="15zcg88p48rg0">
          <NavLink to={to} className={({
        isActive
      }) => `flex items-center gap-2.5 rounded-xl px-3 ${size === 'lg' ? 'py-3' : 'py-2'} text-sm transition-colors duration-150 ${isActive ? 'bg-white/[0.06] text-white' : 'text-gray-300 hover:text-white'}`} data-id="element-370" data-mp="15yko57uq9buh">
            <Icon className="h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-371" data-mp="1jyc7zp7xdmge" />
            {label}
          </NavLink>
        </li>)}
    </ul>;
}